import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import BaseAppBar from 'components/AppBar/BaseAppBar';

// LogoFocused AppBar does not actually render the logo in the app bar
// instead it will render the logo with an avatar in in the Hero.
const LogoFocusedAppBar = props => {
  const { ownState, children, name } = props;
  return (
    <BaseAppBar
      name={name}
      ownState={ownState}
      ToolbarProps={{
        sx: theme => ({
          '&.MuiToolbar-root': {
            height: theme.spacing(8.125),
            px: '5px',
            py: 0
          }
        })
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        {children}
      </Box>
    </BaseAppBar>
  );
};

LogoFocusedAppBar.propTypes = {
  children: PropTypes.node,
  ownState: PropTypes.object,
  name: PropTypes.string
};

export default React.memo(LogoFocusedAppBar);
